import { Building2, ShoppingCart, Heart, GraduationCap, Plane, Landmark, Factory, Zap } from 'lucide-react';

export default function Industries() {
  const industries = [
    {
      icon: Building2,
      name: 'Real Estate & Construction',
      description: 'Digital transformation solutions for property management, CRM, and construction workflow automation.'
    },
    {
      icon: ShoppingCart,
      name: 'Retail & E-Commerce',
      description: 'Omnichannel platforms, inventory management, and personalized shopping experiences.'
    },
    {
      icon: Heart,
      name: 'Healthcare & Life Sciences',
      description: 'HIPAA-compliant solutions, telemedicine platforms, and health data analytics.'
    },
    {
      icon: Landmark,
      name: 'Banking & Financial Services',
      description: 'Secure fintech solutions, payment gateways, and regulatory compliance systems.'
    },
    {
      icon: GraduationCap,
      name: 'Education & E-Learning',
      description: 'Learning management systems, virtual classrooms, and student engagement platforms.'
    },
    {
      icon: Factory,
      name: 'Manufacturing & Supply Chain',
      description: 'IoT integration, predictive maintenance, and supply chain optimization solutions.'
    },
    {
      icon: Plane,
      name: 'Travel & Hospitality',
      description: 'Booking systems, customer experience platforms, and revenue management tools.'
    },
    {
      icon: Zap,
      name: 'Energy & Utilities',
      description: 'Smart grid solutions, asset management, and energy consumption analytics.'
    }
  ];

  return (
    <section id="industries" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-50 rounded-full mb-4">
            <span className="text-blue-600 font-semibold text-sm">INDUSTRIES WE SERVE</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Delivering Excellence Across{' '}
            <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
              Multiple Industries
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our industry expertise spans diverse sectors, enabling us to deliver tailored solutions that address unique business challenges and regulatory requirements.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl p-6 border border-gray-200 hover:shadow-xl hover:border-blue-300 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <industry.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{industry.name}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{industry.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-2xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">Don't See Your Industry?</h3>
          <p className="text-xl text-blue-50 mb-8 max-w-2xl mx-auto">
            We've worked with diverse sectors and adapt quickly to new domains. Let's discuss how we can help transform your business.
          </p>
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-8 py-4 bg-white text-blue-600 rounded-lg font-semibold hover:shadow-xl transition-all duration-300"
          >
            Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
}
